import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { RootReducer } from '../../redux/rootReducer'

const AppStateRefetch = (): JSX.Element => {
  const userDataFetchedAt = useSelector((state: RootReducer) => state.userDataReducer.fetchedAt)
  const userDataFetchedAtRef = useRef(userDataFetchedAt)

  useEffect(() => {
    userDataFetchedAtRef.current = userDataFetchedAt
  }, [userDataFetchedAt])

  useEffect(() => {
    const handleFocus = (): void => {
      if (userDataFetchedAtRef.current !== 0) {
        const thirtyMinutesAgo = Date.now() - 30 * 60 * 1000
        if (userDataFetchedAtRef.current < thirtyMinutesAgo) {
          window.location.reload()
        }
      }
    }

    window.addEventListener('focus', handleFocus)
    return () => {
      window.removeEventListener('focus', handleFocus)
    }
  }, [userDataFetchedAt])

  return <div></div>
}

export default AppStateRefetch
